import { unrefElement } from '@vueuse/core';

export function getBlockRootElement(el: any): HTMLElement | SVGElement | undefined {
	el = unrefElement(el);

	// Skip white space text nodes
	while (el && el.nodeType !== Node.ELEMENT_NODE) {
		el = el.nextElementSibling;
	}

	if (el instanceof HTMLElement) {
		const style = window.getComputedStyle(el);

		if (style.display === 'contents' && el.childNodes[0]) {
			return getBlockRootElement(el.childNodes[0]);
		}
	}

	return el;
}
